import { CloudOff, RefreshCw } from 'lucide-react';
import { useOffline } from '../../hooks/useOffline';

export default function OfflineFallback() {
  const { isOnline, syncNow } = useOffline();

  if (isOnline) return null;

  return (
    <div className="au-offline-fallback" role="alert" aria-live="assertive">
      <div className="au-offline-card">
        <CloudOff className="w-8 h-8 text-amber-500 mb-3" aria-hidden="true" />
        <h2 className="text-lg font-semibold mb-2">Sei offline</h2>
        <p className="text-sm text-gray-600 mb-4">
          Alcuni contenuti potrebbero non essere aggiornati. Riprova quando torni online.
        </p>
        <button
          onClick={syncNow}
          className="au-btn au-btn-primary"
          type="button"
        >
          <RefreshCw className="w-4 h-4 mr-2 inline" aria-hidden="true" />
          Riprova
        </button>
      </div>
    </div>
  );
}
